module.exports = __webpack_public_path__ + "assets/img/5_1166.7d7cc528.jpg";